const reportList = [
  {
    key: 'detail-history-vehicle',
    label: 'report.report.vehicleTripHistory',
    modal: 'detail-riwayat-kendaraan-revamped',
    table: 'detailHistoryVehicleRef',
    event: 'Vehicle History Detail Report',
    desc: 'report.report.desc.vehicleTripHistory',
    link: 'Report Detail Vehicle Trip',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'detailSummaryTrip',
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      },
      interval: {
        value: '',
      },
    },
  },
  {
    key: 'management-vehicle',
    label: 'report.report.vehicleManagement',
    modal: 'manajemen-kendaraan-revamped',
    table: 'managementVehicleRef',
    event: 'Vehicle Management Report',
    desc: 'report.report.desc.fleetManagement',
    link: 'Report Management Vehicle',
    isFavorite: false,
    isSaved: false,
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'managementVehicle',
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'history-vehicle',
    label: 'report.report.summaryVehicleTrip',
    modal: 'riwayat-kendaraan-revamped',
    table: 'historyVehicleRef',
    event: 'Trip History Report',
    desc: 'report.report.desc.summaryVehicleTrip',
    link: 'Report Vehicle Trip',
    isFavorite: false,
    isSaved: false,
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'summaryTrip',
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      driverId: {
        value: [],
      },
    },
  },
  {
    key: 'summary-day',
    label: 'report.report.summaryVehicleUsage',
    modal: 'ringkasan-harian-kendaraan-revamped',
    table: 'summaryDayRef',
    event: 'Vehicle Daily Summary Report',
    desc: 'report.report.desc.summaryVehicleUsage',
    link: 'Report Summary Day Vehicle',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'summaryDay',
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'summary-stopped',
    label: 'report.report.vehicleStopHistory',
    modal: 'waktu-berhenti-revamped',
    table: 'summaryStoppedRef',
    event: 'Stop Time Report',
    desc: 'report.report.desc.vehicleStopHistory',
    link: 'Report Summary Stopped',
    isFavorite: false,
    isSaved: false,
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'summaryStopped',
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      acc: {
        value: [],
      },
    },
  },
  {
    key: 'time-window',
    label: 'report.report.timeWindow',
    modal: 'jendela-waktu-revamped',
    table: 'timeWindowRef',
    event: 'Time Window Report',
    desc: 'report.report.desc.timeWindow',
    link: 'Report Time Window',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'geolocation',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      },
      garageId: {
        value: '',
        required: true,
      },
    },
  },
  {
    key: 'overspeed-durations',
    label: 'report.report.overspeedDurations',
    modal: 'pelanggaran-kecepatan-melebihi-batas-aman-revamped',
    table: 'overspeedDurationRef',
    event: 'Overspeed Duration Report',
    desc: 'report.report.desc.overspeedDurations',
    link: 'Report Overspeed Duration',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'alert',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      },
    },
  },
  {
    key: 'offline-vehicle',
    label: 'report.report.offlineDevice',
    modal: 'kendaraan-offline-revamped',
    table: 'offlineVehicleRef',
    event: 'Offline Vehicle Report',
    desc: 'report.report.desc.offlineDevice',
    link: 'Report Offline Device',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    schedulerEnum: 'offlineVehicle',
  },
  {
    key: 'service-schedules',
    label: 'report.report.serviceSchedules',
    modal: 'service-schedules-revamped',
    table: 'serviceSchedulesRef',
    event: 'Service Schedules Report',
    desc: 'report.report.desc.serviceSchedules',
    link: 'Report Service Schedule',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'service',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      serviceStatus: {
        value: [],
      },
    },
  },
  {
    key: 'history-connectivity-gps',
    label: 'report.report.historyConnectivityGps',
    modal: 'history-connectivity-gps-revamped',
    table: 'historyConnectivityGpsRef',
    event: 'History Connectivity GPS Report',
    desc: 'report.report.desc.historyConnectivityGps',
    link: 'Report History Connectivity Gps',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      },
    },
  },
  {
    key: 'historical-offline',
    label: 'report.report.historicalOffline',
    modal: 'historical-offline-revamped',
    table: 'historicalOfflineRef',
    event: 'Historical Offline GPS Report',
    desc: 'report.report.desc.historicalOffline',
    link: 'Report Historical Offline',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      },
    },
  },

  {
    key: 'summary-work',
    label: 'report.report.summaryWorkingHours',
    modal: 'summary-working-hours-revamped',
    table: 'summaryWorkingHoursRef',
    event: 'Summary Working Hours Report',
    desc: 'report.report.desc.summaryWorkingHours',
    link: 'Report Summary Working Hours',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      },
    },
  },
  {
    key: 'summary-engine',
    label: 'report.report.summaryEngine',
    modal: 'detail-jam-kerja-revamped',
    table: 'summaryEngineRef',
    event: 'Working Hours Detail Report',
    desc: 'report.report.desc.summaryEngine',
    link: 'Report Summary Engine',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'geolocation',
    label: 'report.report.geolocationHistory',
    modal: 'geolokasi-revamped',
    table: 'geolocationRef',
    event: 'Geofence Report',
    desc: 'report.report.desc.geolocationHistory',
    link: 'Report Geolocation',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'geolocation',
    category: ['fleet'],
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'geolocation',
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      driverId: {
        value: [],
      },
      geofenceId: {
        value: [],
      },
      condition: {
        value: [],
      },
    },
  },
  {
    key: 'summary-geolocation',
    label: 'report.report.vehicleTripDuration',
    modal: 'ringkasan-geolokasi-revamped',
    table: 'summaryGeolocationRef',
    event: 'Geofence Summary Report',
    desc: 'report.report.desc.summaryTripGeolocation',
    link: 'Report Summary Geolocation',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'geolocation',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      geofenceId: {
        value: [],
      },
    },
  },
  {
    key: 'alert',
    label: 'report.report.vehicleAlertHistory',
    modal: 'peringatan-revamped',
    table: 'alertRef',
    event: 'Alert Report',
    desc: 'report.report.desc.vehicleAlertHistory',
    link: 'Report Alert',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'alert',
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'alert',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      alertCode: {
        value: [],
        required: true,
      },
      driverId: {
        value: [],
      },
      falseAlert: {
        value: '',
      },
      isImportant: {
        value: ''
      }
    },
  },
  {
    key: 'summary-alert',
    label: 'report.report.summaryVehicleAlert',
    modal: 'summary-alert-revamped',
    table: 'summaryAlertRef',
    event: 'Summary Alert Report',
    desc: 'report.report.desc.summaryVehicleAlert',
    link: 'Report Summary Alert',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'alert',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      driverId: {
        value: [],
      },
    },
  },
  {
    key: 'fuel',
    label: 'report.report.fuelHistory',
    modal: 'bahan-bakar-revamped',
    table: 'fuelRef',
    event: 'Fuel Report',
    desc: 'report.report.desc.fuelHistory',
    link: 'Report Fuel',
    isFavorite: false,
    isSaved: false,
    downloadOptions: ['pdf', 'xlsx', 'csv', 'graph'],
    schedulerEnum: 'fuel',
    domain: 'fleet',
    section: 'fuel',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      },
      interval: {
        value: '',
      },
      summaryChart:{
        value: '',
      }
    },
  },
  {
    key: 'summary-fuel',
    label: 'report.report.summaryVehicleFuel',
    modal: 'ringkasan-bahan-bakar-revamped',
    table: 'summaryFuelRef',
    event: 'Fuel Summary Report',
    desc: 'report.report.desc.summaryVehicleFuel',
    link: 'Report Summary Fuel',
    isFavorite: false,
    isSaved: false,
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'summaryFuel',
    domain: 'fleet',
    section: 'fuel',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'summary-day-fuel',
    label: 'report.report.summaryDayVehicleFuel',
    modal: 'ringkasan-harian-bahan-bakar-revamped',
    table: 'summaryDayFuelRef',
    event: 'Fuel Daily Summary Report',
    desc: 'report.report.desc.summaryDayVehicleFuel',
    link: 'Report Daily Summary Fuel',
    isFavorite: false,
    isSaved: false,
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'summaryDayFuel',
    domain: 'fleet',
    section: 'fuel',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'temperature',
    label: 'report.report.temperatureHistory',
    modal: 'temperatur-revamped',
    table: 'temperatureRef',
    event: 'Temperature Report',
    desc: 'report.report.desc.temperatureHistory',
    link: 'Report Temperature',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'temperature',
    downloadOptions: ['pdf', 'xlsx', 'csv', 'graph'],
    schedulerEnum: 'temperature',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      },
      interval: {
        value: '',
      },
    },
  },
  {
    key: 'door',
    label: 'report.report.doorDuration',
    modal: 'pintu-revamped',
    table: 'doorRef',
    event: 'Door Report',
    desc: 'report.report.desc.doorDuration',
    link: 'Report Door',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'door',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      driverId: {
        value: [],
      },
    },
  },
  {
    key: 'summary-engine-pto',
    label: 'report.report.summaryEnginePto',
    modal: 'ringkasan-jam-kerja-dan-pto-revamped',
    table: 'summaryEnginePTORef',
    event: 'Working Hours and PTO Summary Report',
    desc: 'report.report.desc.summaryEnginePto',
    link: 'Report Summary Engine PTO',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'pto',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      },
    },
  },
  {
    key: 'detail-pto',
    label: 'report.report.ptoActiveDuration',
    modal: 'detail-pto-revamped',
    table: 'detailPTORef',
    event: 'PTO Detail Report',
    desc: 'report.report.desc.ptoActiveDuration',
    link: 'Report Detail PTO',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'pto',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'cost-analysis',
    label: 'report.report.costAnalysis',
    modal: 'cost-analysis-revamped',
    table: 'costAnalysisRef',
    event: 'Cost Anaysis Report',
    desc: 'report.report.desc.costAnalysis',
    link: 'Report Cost Analysis',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'delivery',
    category: ['delivery'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
    },
    shown: true,
  },
  {
    key: 'management-driver',
    label: 'report.report.driverManagement',
    modal: 'manajemen-pengemudi-revamped',
    table: 'managementDriverRef',
    event: 'Driver Management Report',
    desc: 'report.report.desc.driverManagement',
    link: 'Report Driver Management',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'driver',
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'managementDriver',
    category: ['driver'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      driverId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'summary-day-driver',
    label: 'report.report.summaryDriver',
    modal: 'ringkasan-harian-pengemudi-revamped',
    table: 'summaryDayDriverRef',
    event: 'Driver Daily Summary Report',
    desc: 'report.report.desc.summaryDriver',
    link: 'Report Daily Summary Driver',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    schedulerEnum: 'summaryDayDriver',
    section: 'driver',
    category: ['driver'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      driverId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'driver-score',
    label: 'report.report.summaryDriverViolation',
    modal: 'penilaian-pengemudi-revamped',
    table: 'driverScoreRef',
    desc: 'report.report.desc.summaryDriverViolation',
    link: 'Report Driver Score',
    event: 'Driver Score Report',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'driver',
    category: ['driver'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      driverId: {
        value: [],
        required: true,
      },
      grade: {
        value: [],
      },
    },
    shown: false,
  },
  {
    key: 'geofences-trip',
    label: 'report.report.tripsBetweenGeofences',
    modal: 'tripsBetweenGeofences-revamped',
    table: 'tripsBetweenGeofencesRef',
    event: 'Trip Between Geofences Report',
    desc: 'report.report.desc.tripsBetweenGeofences',
    link: 'Report Trip Between Geofences',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'geolocation',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      startGeofenceId: {
        value: '',
        required: true,
      },
      endGeofenceId: {
        value: '',
        required: true,
      },
      intersectGeofenceIds: {
        value: [],
      },
    },
  },
  {
    key: 'history-route',
    label: 'report.report.historyRoute',
    modal: 'riwayat-rute-revamped',
    table: 'historyRouteRef',
    event: 'Report History Route',
    desc: 'report.report.desc.historyRoute',
    link: 'Report History Route',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'summary-ritage-route',
    label: 'report.report.summaryRitageRoute',
    modal: 'summary-ritage-route-revamped',
    table: 'summaryRitageRouteRef',
    event: 'Report Summary Ritage Route',
    desc: 'report.report.desc.summaryRitageRoute',
    link: 'Report Summary Ritage Route',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'vehicle-last-location',
    label: 'report.report.vehicleStatus',
    modal: 'status-kendaraan-revamped',
    table: 'vehicleStatusRef',
    event: 'Vehicle Status Report',
    desc: 'report.report.desc.vehicleStatus',
    link: 'Report Vehicle Status',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      vehicleId: {
        value: [],
        required: true,
      },
    },
  },
  {
    key: 'duration-in-geolocation',
    label: 'report.report.vehicleDuration',
    modal: 'durasi-geolokasi-revamped',
    table: 'geolocationDurationsRef',
    event: 'Geofence Duration Report',
    desc: 'report.report.desc.vehicleDuration',
    link: 'Report Geofence Duration',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'geolocation',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      geofenceId: {
        value: [],
      },
    },
  },
  {
    key: 'fleet-utilization-ijp',
    label: 'report.report.fleetUtilization',
    modal: 'fleet-utilization-ijp-revamped',
    table: 'fleetUtilizationIjpRef',
    event: 'Fleet Utilization IJP',
    desc: 'report.report.desc.fleetUtilization2',
    link: 'Report Fleet Utilization IJP',
    isFavorite: false,
    isSaved: false,
    domain: 'fleet',
    section: 'fleet',
    category: ['fleet'],
    filter: {
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: [],
        required: true,
      },
      geofenceId: {
        value: [],
        multiple: false,
        required: true,
      },
    },
  },
  {
    key: 'fuel-recapitulation',
    label: 'report.report.fuelRecapitulation',
    modal: 'rekapitulasi-bahan-bakar-revamped',
    table: 'fuelRef',
    event: 'Fuel Recapitulation Report',
    desc: 'report.report.desc.fuelRecapitulation',
    link: 'Report Fuel Recapitulation',
    isFavorite: false,
    isSaved: false,
    downloadOptions: ['pdf', 'xlsx', 'csv'],
    // schedulerEnum: 'fuelRecapitulation',
    domain: 'fleet',
    section: 'fuel',
    category: ['fleet'],
    filter: {
      reportType: {
        value: '',
        required: true
      },
      periode: {
        value: [],
        required: true,
      },
      vehicleId: {
        value: '',
        required: true,
      }
    },
  },
]

export default reportList
